export enum local_storage_key {
    access_complaint_channel = 'WhvfvLjwJObHpQvXTtyexQe',
    _idUser = '_idUser',
    _idEmployee = 'HvkxwqqUaw41dIBJvaEh',
    _idEmployer = '_idEmployer',
    user_photo = 'LVmxzkLjwJs8f07Vv3Eg',
    user_phone = 'vvXQeObHpQWhfvT',
    user_profile = 'userProfile',
    user_role = 'WhvfvObHpQvXTQe',
    user_name = 'userName',
    user_surname = 'userSurname',
    user_event_flag = 'uhfserqqUSuQeOme',
    user_jwt = 'yvwokxhqawkaqazislzi',
    user_refresh_jwt = 'scrjwodtyexeybvbabmp',
    employer_name = 'employerName',
    login_all_employees = 'scrjwodgtyexeysbvbafbmp',
    email_login = 'emailLogin',
    token = 'token',
    hash_encrypt = 'LTdxZfemnSdDIhsDeaKea',
    key_job = 'cecyzbrtgscecyzbrtgs'
}

